import { createFileRoute, useParams } from '@tanstack/react-router';

import { QuizAttemptView } from '@/views/quizzes/quiz-attempt-view.tsx';

// 学生尝试页：作答（IN_PROGRESS）或回看（终态）。也服务
// survey + 自评，复用 quiz 尝试机制——视图根据服务器响应的
// `kind` 分支。
export const Route = createFileRoute('/_learner/courses_/$id/quizzes/$quizId/attempts/$attemptId')({
  component: AttemptPage,
});

function AttemptPage() {
  const { id, quizId, attemptId } = useParams({
    from: '/_learner/courses_/$id/quizzes/$quizId/attempts/$attemptId',
  });
  return <QuizAttemptView courseId={id} quizId={quizId} attemptId={attemptId} />;
}
